<template>
  <v-dialog
    v-model="show"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="text-h5">
        <v-icon
          class="mr-2"
          color="black"
        >
          mdi-content-save-outline
        </v-icon>
        <span class="text-h5">{{ localize('projectHasBeenSaved') }}</span>
        <v-spacer />
        <v-btn
          icon
          @click="show = false"
        >
          <v-icon color="black">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <span class="text-body1"> {{ localize('projectCodeSummary') }} </span>
      </v-card-text>

      <v-card-text>
        <span class="text-h4 row justify-center my-2">{{ code }}</span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'ProjectCode',

    props: {
      value: Boolean,
      code: String,
    },

    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },

  }
</script>
